import { css } from '@emotion/core';
const styles = (theme, active) => ({
  panel: css`
    div&.vds-panel.vds-state--open:not(.vds-state--animated) {
      height: 100%;
      width: 30rem;
      margin: 0;
      max-width: calc(100vw - 2rem);
      min-width: 18rem;
      position: fixed;
      top: 0;
      right: 0;
      cursor: auto;
      padding: 1.5rem;
      overflow: auto;
      word-break: break-word;
      white-space: normal;
      box-shadow: 0 0 4px ${theme?.cybs?.base?.wcag21?.stoneGrey ?? '#62798D'};

      & > .vds-panel-panel:nth-of-type(1) {
        position: relative;
        overflow: visible;
        width: 100%;
        max-width: 100%;
        min-height: auto;

        & .vds-panel-content {
          width: 100%;
          position: initial;
          padding: 0;
          font-weight: 400 !important;
          max-width: 100%;
        }
      }
    }
    .vds-panel-panel .vds-panel-content {
      min-height: 100%;
    }
  `,
  titleText: css`
    color: ${theme?.cybs?.base?.wcag21?.charcoal ?? '#000000'};
    font-weight: 600;
    font-size: 1.25rem;
    text-transform: none;
    flex: 1;
    &:focus {
      outline: dashed 1px !important;
    }
  `,
  closeButton: css`
    button {
      margin: 2px;
    }
  `,
  tooltip: css`
    &.vds-tooltip {
      z-index: 2000;
    }
  `,
  panelBody: css`
  width: 100%;
  ${theme?.classes?.structure?.margin?.space?.top?.[2] || 'margin-top: 1rem;'};
  `
});

export default styles;
